// import axios from 'axios'

import { url } from './endPoint'
import store from '../redux/store'

export const req = (method, prefix, data, upload = false, auth = true) => {
    return new Promise((done, fail) => {
        if (auth) {
            let { user } = store.getState()
            if (!user.loggedIn) return fail("User not loggedIn")
            let { token } = user.user || ""
            if (upload === true) {
                return done(fetchUpload(method, prefix, data, token))
            }
            return done(fetchReq(method, prefix, data, token))
        }
        return done(fetchReq(method, prefix, data, ""))
    })
}

const fetchReq = (method, prefix, data, token) => {
    let fullPath = false
    if (prefix.includes("http")) {
        fullPath = true
    }
    return fetch(fullPath ? prefix : `${url}/${prefix}`, {
        method, // *GET, POST, PUT, DELETE, etc.
        mode: "cors",
        cache: "no-cache",
        headers: {
            "Content-Type": "application/json; charset=utf-8",
            "auth": `auth ${token}`
        },
        body: JSON.stringify(data),
    })
        .then(response => response.json());
}

const fetchUpload = (method, prefix, data, token) => {
    let fullPath = false
    if (prefix.includes("http")) {
        fullPath = true
    }
    return fetch(fullPath ? prefix : `${url}/${prefix}`, {
        method, // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, cors, *same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        // credentials: "include", // include, same-origin, *omit
        headers: {
            // "Content-Type": "application/json; charset=utf-8",
            // "Content-Type": "application/x-www-form-urlencoded",
            "auth": `auth ${token}`
        },
        body: data, // body data type must match "Content-Type" header
    })
        .then(response => response.json()); // parses response to JSON
}


export const wailonReq = async (svc = "", params = {}, sid = "") => {
    const url = "https://hst-api.wialon.com/wialon/ajax.html?"
    let p = new URLSearchParams({
        svc,
        sid,
        params: JSON.stringify(params)
    })
    try {
        const response = await fetch(url + p, {
            method: "POST",
            mode: "no-cors",
            crossDomain: true,
            cache: "no-cache",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                'Accept': 'application/json',
            }
        });
        // let data = await response.text()
        // let jsonData = await response.json()
        // console.log(response, data)
        return await response.json();
    } catch (err) {
        console.log(err)
        return ({ success: false, msg: "", err });
    }
}

export const wailonApi = async (svc = "", params = {}) => {
    let sid = await getWailonSid()
    if (!sid) throw new Error("Fail to get sid")
    return wailonReq(svc, params, sid)
}


export const getWailonSid = async () => {
    let wialonToken = "56abb1c779abf9b18c34adba387dcebf0629366FA90B0F3AB0F51954801586A64657F716"
    try {
        let { eid = "" } = await wailonReq("token/login", { token: wialonToken })
        return eid
    } catch (err) {
        console.error(err)
        return ""
    }
}